import { USER } from "data/ss-data-store";
import { removeAllCookies, resetAnalytics, trackEvent } from "utils";

/**
 * Logout user and redirect to homepage.
 *
 * @param returnTo - an optional destination to return to if the user logs in
 * @param redirect - an optional redirect function
 */
export function logout(returnTo?: string) {
  trackEvent("Log Out");
  resetAnalytics();
  removeAllCookies();
  const query = returnTo ? `?to=${encodeURIComponent(returnTo)}` : "";
  const destination = `/auth/logout${query}`;
  window.location.href = destination;
}

export function isLoggedIn() {
  return !!USER;
}

export function authUser() {
  return USER;
}

/**
 * Adds headers to requests to backend. Mostly acts as a bridge between old
 * system and Universal Login.
 *
 * Does nothing if legacy auth. If universal adds token and custom headers so
 * proxy knows to pass the request through to keystone.
 *
 * @param base - headers object to extend
 * @param throughProxy - set to false if request is going directly to keystone-api
 * @returns
 */
export function authHeaders(
  base: Record<string, string> = {},
  throughProxy = true,
) {
  const headers = base;
  if (USER?.token) {
    headers.Authorization = `Bearer ${USER.token}`;
  }
  if (throughProxy) {
    headers["x-universal-login"] = "?1";
    if (USER) {
      headers["x-username"] = USER.email;
    }
  }
  return headers;
}
